import {
  auFlagSvgSrc,
  caFlagSvgSrc,
  euFlagSvgSrc,
  sgFlagSvgSrc,
  ukFlagSvgSrc,
  usFlagSvgSrc,
  zaFlagSvgSrc,
} from "@ms/gatsby-theme";

import type { NavCountriesInterface } from "@/types/navigation";
import type { MsProduct } from "@/types/product";

export const countries: NavCountriesInterface[] = [
  {
    countryCode: "US",
    text: "US",
    displayName: "United States",
    baseUrl: "https://www.manscaped.com",
    svgSrc: usFlagSvgSrc,
  },
  {
    countryCode: "CA",
    text: "CA",
    displayName: "Canada",
    baseUrl: "https://ca.manscaped.com",
    svgSrc: caFlagSvgSrc,
  },
  {
    countryCode: "EU",
    text: "EUR",
    displayName: "Europe",
    baseUrl: "https://eu.manscaped.com",
    svgSrc: euFlagSvgSrc,
  },
  {
    countryCode: "UK",
    text: "UK",
    displayName: "United Kingdom",
    baseUrl: "https://uk.manscaped.com",
    svgSrc: ukFlagSvgSrc,
  },
  {
    countryCode: "AU",
    text: "AU/NZ",
    displayName: "Australia / New Zealand",
    baseUrl: "https://au.manscaped.com",
    svgSrc: auFlagSvgSrc,
  },
  {
    countryCode: "SG",
    text: "SG",
    displayName: "Singapore",
    baseUrl: "https://sg.manscaped.com",
    svgSrc: sgFlagSvgSrc,
  },
  {
    countryCode: "ZA",
    text: "ZA",
    displayName: "South Africa",
    baseUrl: "https://za.manscaped.com",
    svgSrc: zaFlagSvgSrc,
  },
];

/* CONSTANTS */
export const LS_DISCOUNT_CODE = "ms_discount_code";

export const LS_SHOPIFY_CART_ID = "ms_shopify_cart_id";

/**
 *  If this constant in Local Storage equals 1, then the ipgeolocation redirect modal will not appear.
 *  We did this so users don't get spammed with redirect modals whenever they switch sites.
 */
export const LS_REDIRECT = "ms_redirect";

export const LS_LANG_REDIRECT = "ms_lang_redirect";

export const LS_PREV_USER = "session_hash";

export const LS_PENDING_EMAIL_LOGOUT = "ms_pending_email_logout";

export const COOKIE_DISCOUNT_IS_DISMISS = "isToastDismissed";

export const SHOP_ALL_SLUG = "shop-all";

const domain = (() => {
  if (process.env.LOCAL_AUTH_URL) {
    return process.env.LOCAL_AUTH_URL.replace("https://", "");
  }
  if (process.env.MS_ENVIRONMENT === "production") {
    return ".manscaped.com";
  }
  const isPreview = ["deploy-preview", "branch-deploy"].includes(process.env.CONTEXT || "");
  if (isPreview && process.env.DEPLOY_PRIME_URL) {
    return process.env.DEPLOY_PRIME_URL.replace("https://", "");
  }

  return ".manscaped.io";
})();

export const COOKIE_OPTIONS = {
  domain: domain,
  maxAge: 24 * 60 * 60,
  path: "/",
};

export const strapiLanguages = process.env.STRAPI_LANGUAGES ? process.env.STRAPI_LANGUAGES : "en";

export const strapiLanguagesArray = strapiLanguages.split(",");

export type SubscriptionCancelSource = "CONTACT_FORM" | "ACCOUNT";

export const MARKET_HANDLE_KEY = (process.env.MS_MARKET ?? "US").toLowerCase() as keyof NonNullable<
  MsProduct["handles"]
>;
